export const backgroundColors = {
    lava120: 'lava120',
    lava80: 'lava80',
    lava60: 'lava60',
    lava40: 'lava40',
    lava20: 'lava20',
    lava10: 'lava10',
    lava5: 'lava5',
    lava: 'lava',
    ocean120: 'ocean120',
    ocean80: 'ocean80',
    ocean60: 'ocean60',
    ocean40: 'ocean40',
    ocean20: 'ocean20',
    ocean10: 'ocean10',
    ocean5: 'ocean5',
    ocean: 'ocean',
    sun120: 'sun120',
    sun80: 'sun80',
    sun60: 'sun60',
    sun40: 'sun40',
    sun20: 'sun20',
    sun10: 'sun10',
    sun5: 'sun5',
    sun: 'sun',
    white: 'white',
    transparent: 'transparent',
};
export const backgroundImages = {
    BlockyRetro: 'blockyRetro.png',
    Lava20Cropped: 'lava20Cropped.png',
    Sun40Cropped: 'sun40Cropped.png',
};
export function isBackgroundStyle(background) {
    return background === 'Lava40Dotty' || background === 'Sun60Dotty';
}
export function mapBackgroundStyleToColor(background) {
    const backgroundStyleNames = ['Dotty'];
    for (const name of backgroundStyleNames) {
        const color = background.split(name)[0].toLowerCase();
        if (color in backgroundColors) {
            return color;
        }
    }
    return 'transparent';
}
/**
 * Narrow type predicate. Determines if is BackgroundImage
 * https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */
export function isBackgroundImage(background) {
    return background in backgroundImages;
}
export function getBackgroundImage(background) {
    return backgroundImages[background];
}
//# sourceMappingURL=background.js.map